import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";
import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import type { OptionalTenantProp } from "../../../types";

const baseSeparatorVariants = cva({
  base: "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:h-10",
});

export interface BaseSeparatorProps
  extends SeparatorPrimitive.Props,
    OptionalTenantProp {
  className?: string;
}

function BaseSeparator({
  className,
  orientation = "horizontal",
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      className={cn(baseSeparatorVariants({}), className)}
      data-slot="separator"
      orientation={orientation}
      {...props}
    />
  );
}

export { BaseSeparator };
